import React from "react";
import dayjs from "dayjs";

const PtoDetails = ({ employee, onClose }) => {
  if (!employee) return null;

  // Format date using Day.js → Dec 20, 2025
  const formatDate = (date) => {
    if (!date) return "-";
    return dayjs(date).isValid()
      ? dayjs(date).format("MMM DD, YYYY")
      : "-";
  };

  const getValue = (val) => (val && val !== "" ? val : "-");

  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-[500px]">
        {/* Header */}
        <div className="flex justify-between items-center border-b px-3 py-2">
          <h2 className="text-[18px] font-semibold text-[#101828]">
            PTO Requests for {getValue(employee.emp_name)}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-xl"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="p-3">
          <div className="border border-[#E5E7EB] flex flex-col justify-start items-start rounded-xl p-3 bg-white">

            {/* Vacation + Status */}
            <div className="flex justify-center items-center gap-2 mb-3">
              <div className="font-normal text-[16px] font-inter text-[#101828]">
                {getValue(employee.request_type)}
              </div>
              <div className="bg-[#FEF9C2] px-[6px] py-[2px] rounded-full">
                <div className="text-[#A65F00] text-[12px] font-inter font-medium">
                  {getValue(employee.status)}
                </div>
              </div>
            </div>

            {/* From / To */}
            <div className="grid grid-cols-2 gap-y-1 mb-3">
              <div className="flex justify-center items-center gap-2">
                <div className="text-[#6A7282] text-[16px] font-inter font-normal">
                  From:
                </div>
                <div className="text-[#4A5565] font-inter font-normal text-[16px]">
                  {formatDate(employee.start_date)}
                </div>
              </div>

              <div className="flex justify-center items-center gap-2">
                <div className="text-[#6A7282] text-[16px] font-inter font-normal">
                  To:
                </div>
                <div className="text-[#4A5565] font-inter font-normal text-[16px]">
                  {formatDate(employee.end_date)}
                </div>
              </div>
            </div>

            {/* Duration */}
            <div className="flex justify-center items-center gap-2">
              <div className="text-[#6A7282] text-[16px] font-inter font-normal">
                Duration:
              </div>
              <div className="text-[#4A5565] font-inter font-normal text-[16px]">
                {getValue(employee.total_hours)}
              </div>
            </div>

            {/* Reason */}
            <div className="flex justify-center items-center gap-2 mt-3">
              <div className="text-[#6A7282] text-[16px] font-inter font-normal">
                Reason:
              </div>
              <div className="text-[#4A5565] font-inter font-normal text-[16px]">
                {getValue(employee.reason)}
              </div>
            </div>
 <div className="flex justify-center items-center gap-2 mt-3">
              <div className="text-[#6A7282] text-[16px] font-inter font-normal">
               Work Coverage:
              </div>
              <div className="text-[#4A5565] font-inter font-normal text-[16px]">
                {getValue(employee.work_coverage)}
              </div>
            </div>
             <div className="flex justify-center items-center gap-2 mt-3">
              <div className="text-[#6A7282] text-[16px] font-inter font-normal">
               Emergency Contact:
              </div>
              <div className="text-[#4A5565] font-inter font-normal text-[16px]">
                {getValue(employee.emergency_contact)}
              </div>
            </div>
            {/* Approved On */}
            {employee.approved_on?<div className="flex justify-center items-center gap-2 mt-3">
              <div className="text-[#6A7282] text-[16px] font-inter font-normal">
                Approved On:
              </div>
              <div className="text-[#4A5565] font-inter font-normal text-[16px]">
                {formatDate(employee.approved_on)}
              </div>
            </div>:<></>}

          </div>
        </div>
      </div>
    </div>
  );
};

export default PtoDetails;
